module.exports = __webpack_public_path__ + "static/media/m3.7c91c565.png";